import get from 'lodash/get'
import { Record as RaRecord, required, SelectInput, TextInput } from 'react-admin'

import { upload } from 'api/jobs'
import { BaseUploadButton } from 'components/Common/UploadButton'
import { DocumentType, DocumentTypeChoices } from '../../helpers/constants'
import { hasPermission, Permissions } from '../../Permissions'

interface UploadDocumentButtonProps {
  record?: RaRecord
  permissions: any
}

const validateDescription = (value: any, allValues: any) => {
  const type = get(allValues, 'type')
  if (!value && type === DocumentType.Other) {
    return 'Description is required'
  }
  return undefined
}

const formDataInputs = [
  {
    name: 'type',
    input: SelectInput,
    choices: DocumentTypeChoices,
    validate: required(),
    isTop: true,
  },
  {
    name: 'description',
    input: TextInput,
    choices: undefined,
    validate: validateDescription,
    isTop: true,
  },
]

const fileFieldInputs = [
  {
    name: 'attachments',
  },
]

export const UploadDocumentButton = ({ record, permissions }: UploadDocumentButtonProps) => {
  if (!permissions) return null
  const canUploadDocument = hasPermission(permissions, Permissions.AddDocument)

  return canUploadDocument ? (
    <BaseUploadButton
      record={record}
      uploadFunction={upload}
      fileFieldInputs={fileFieldInputs}
      formDataInputs={formDataInputs}
      dialogTitle="Upload Job Document"
      buttonLabel="Upload New Document"
      multiple={true}
    />
  ) : null
}

export const UploadRateConButton = ({ record, permissions }: UploadDocumentButtonProps) => {
  const canUploadDocument = hasPermission(permissions, Permissions.AddDocument)

  const rateConFormDataInputs = formDataInputs.map((input) => {
    if (input.name === 'type') {
      return {
        ...input,
        choices: DocumentTypeChoices.filter((choice) => choice.id === DocumentType.RateConfirmation),
        value: DocumentType.RateConfirmation,
      }
    }
    return input
  })

  return canUploadDocument ? (
    <BaseUploadButton
      record={record}
      uploadFunction={upload}
      fileFieldInputs={fileFieldInputs}
      formDataInputs={rateConFormDataInputs}
      dialogTitle="Upload Rate Confirmation"
      buttonLabel="Upload Rate Con"
      multiple
    />
  ) : null
}
